module.exports = __webpack_public_path__ + "img/logo-dark.1eaea830.png";